import clsx from "clsx";
import { useSetAtom } from "jotai";
import { FC, ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { navbarAtom } from "../../lib/atoms";

interface Props {
  label: string;
  to: string;
  icon: ReactNode;
}

const MenuLink: FC<Props> = ({ icon, label, to }) => {
  const setNavbar = useSetAtom(navbarAtom);

  return (
    <NavLink
      to={to}
      onClick={() => setNavbar(false)}
      className={({ isActive }) =>
        clsx(
          "font-medium p-2 flex space-x-5 hover:bg-slate-100 rounded-lg items-center text-slate-600 active:bg-slate-200 hover:text-slate-800",
          {
            "bg-slate-100 text-slate-700": isActive,
          }
        )
      }
    >
      <div className="h-5 w-5 text-slate-700">{icon}</div>

      <div>{label}</div>
    </NavLink>
  );
};

export default MenuLink;
